import { render, staticRenderFns } from "./DropShipOrder.vue?vue&type=template&id=4da9aaea&scoped=true&"
import script from "./DropShipOrder.vue?vue&type=script&lang=js&"
export * from "./DropShipOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9aaea",
  null
  
)

export default component.exports